import PageData from "../../PageData";
import tracking from "../tracking";
import {EventBus} from "../../events/EventBus";
import {MARKET_STATS_CLICKED_EVENT_TYPE, MARKET_STATS_VIEWED_EVENT_TYPE} from "../../tracking/constants";

export class MarketStatsTracking {
    private viewed = false;

    init(pageData: PageData) {
        tracking.init();
        this.subscribeMarketStatsClicked(pageData, ".js-market-stats-tracking-clicked");
        this.subscribeMarketStatsViewed(pageData, 'serp-market-stats');
    }

    private subscribeMarketStatsViewed(pageData: PageData, selectorId: string) {
        const marketStatsContainer = document.getElementById(selectorId);
        document.addEventListener('scroll', () => this.emitCommonEvent(marketStatsContainer, pageData))
    }

    private subscribeMarketStatsClicked(pageData: PageData, selector: string) {
        document.querySelectorAll<HTMLElement>(selector).forEach(
            (element) => element.addEventListener('click', this.emitClickedEvent.bind(this, element, pageData)));
    }

    private emitCommonEvent(element: HTMLElement | null, pageData: PageData) {
        if (element == null) {
            return
        }

        if (this.viewed || !this.isInView(element)) {
            return;
        }
        this.viewed = true

        let trackingData = element.dataset.tracking_viewed;
        if (trackingData === undefined) {
            return
        }

        let parseTrackingData = JSON.parse(trackingData.replace(/'/g, '"'));
        let eventBus = EventBus.getInstance();
        eventBus.emit(new tracking.TrackWebTrackingEvent(
            {
                type: MARKET_STATS_VIEWED_EVENT_TYPE,
                serpUrl: window.location.href,
                sectionName: parseTrackingData.sectionName,
                section: parseTrackingData.section,
                pageViewId: pageData.pageViewId,
                filters: {
                    operationType: parseTrackingData.operationType,
                    propertyType: parseTrackingData.propertyType,
                    geoId: parseTrackingData.geoId,
                },
            }
        ));
    }

    private isInView(container: HTMLElement, percentageViewed = 0.20) {
        const containerBox = container.getBoundingClientRect()

        const heightViewed = containerBox.height * percentageViewed;
        let topLimit = containerBox.top + heightViewed;
        const bottomLimit = topLimit + window.innerHeight - heightViewed;

        const screenBottom = window.screenTop + window.innerHeight

        let topInView = topLimit >= window.screenTop && topLimit <= screenBottom;
        let bottomInView = bottomLimit >= window.screenTop && bottomLimit <= screenBottom;

        return (topInView || bottomInView)
    }

    private emitClickedEvent(element: HTMLElement, pageData: PageData) {
        let trackingData = element.dataset.tracking;
        if (trackingData === undefined) {
            return
        }

        let parseTrackingData = JSON.parse(trackingData.replace(/'/g, '"'));
        let eventBus = EventBus.getInstance();
        eventBus.emit(new tracking.TrackWebTrackingEvent(
            {
                type: MARKET_STATS_CLICKED_EVENT_TYPE,
                serpUrl: window.location.href,
                sectionName: parseTrackingData.sectionName,
                section: parseTrackingData.section,
                pageViewId: pageData.pageViewId,
                filters: {
                    operationType: parseTrackingData.operationType,
                    propertyType: parseTrackingData.propertyType,
                    geoId: parseTrackingData.geoId,
                    rooms: parseTrackingData.rooms,
                    amenity: parseTrackingData.amenity,
                    alternativeGeoId: parseTrackingData.alternativeGeoId,
                    stratum: parseTrackingData.stratum,
                },
            }
        ));
    }
}
